export const orderTableHead = [
  // {
  //   title: '#',
  //   name: 'userFileId',
  //   sortDirection: 'ASC',
  //   isSort: true,
  //   isFilter: false,
  // },
  {
    title: 'Files',
    name: 'outputFile',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Order name',
    name: 'name',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'SkipTrace Type',
    name: 'SkipTraceType',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Total Records',
    name: 'totalRecords',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Hits',
    name: 'successfullRecords',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Hit Rate',
    name: 'hitRate',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Duplicates',
    name: 'duplicates',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Email',
    name: 'email',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'Litigator',
    name: 'blacklist',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  {
    title: 'DNC',
    name: 'DNC',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
  // {
  //   title: 'Failed',
  //   name: 'failedRecords',
  //   sortDirection: 'ASC',
  //   isSort: true,
  //   isFilter: false,
  // },
  {
    title: 'Status',
    name: 'status',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: true,
  },
  {
    title: 'Price',
    name: 'price',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  // {
  //   title: 'Notes',
  //   name: 'notes',
  //   sortDirection: 'ASC',
  //   isSort: true,
  //   isFilter: false,
  // },
  {
    title: 'Date',
    name: 'createdAt',
    sortDirection: 'ASC',
    isSort: true,
    isFilter: false,
  },
  {
    title: 'Actions',
    name: 'actions',
    sortDirection: 'ASC',
    isSort: false,
    isFilter: false,
  },
];
